import React from 'react';
import { AttendanceTrackingPageHeader } from 'components/molecules/AttendanceTrackingPageHeader';
import ManagerLeaveRequests from './ManagerLeaveRequests';
import './index.scss';

export const ManagerLeaveApprovals = () => {
  return (
    <div className="manager-leave-approvals-page">
      <AttendanceTrackingPageHeader
        title="Leave Approvals"
        crumbs={[{ label: 'Manager Portal' }, { label: 'Leave Approvals' }]}
      />
      <ManagerLeaveRequests />
    </div>
  );
};
